import { render, staticRenderFns } from "./EditPointCard.vue?vue&type=template&id=8224864c&scoped=true"
import script from "./EditPointCard.vue?vue&type=script&lang=js"
export * from "./EditPointCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8224864c",
  null
  
)

export default component.exports